import { render } from "./InputField.vue?vue&type=template&id=c8637f6e"
import script from "./InputField.vue?vue&type=script&lang=js"
export * from "./InputField.vue?vue&type=script&lang=js"

import "./InputField.vue?vue&type=style&index=0&id=c8637f6e&lang=css"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__